$(document).on('change', '.js-hideFormField input:not(.js-fileUploadInput)', (event) => {
  inputHideTrigger($(event.currentTarget))
})

$(document).on('change', '.js-hideFormField .js-select', (event) => {
  selectHideTrigger($(event.currentTarget))
})

function selectHideTrigger(field) {
  const elem = field
  const id = elem.val()
  const selectListId = elem.attr('id')

  elem.find('option').each((index, item) => {
    if (id !== $(item).val()) {
      showFieldById($(item).val())
    }
  })

  if (id != 0) {
    hideFieldById(id)
    hideFieldById(selectListId)
  } else {
    showFieldById(selectListId)

    elem.find('option').each((index, item) => {
      showFieldById($(item).val())
    })
  }
}

function inputHideTrigger(field) {
  const elem = field
  const id = elem.attr('id')

  if (elem.attr('type') === 'checkbox' || elem.attr('type') === 'radio') {
    const checkboxList = elem.parents('.js-checkboxList')
    const checkboxListId = checkboxList.attr('id')

    // если хотя бы одно из списка checked показываем нужный блок по id
    if (checkboxList.find('input:checked').length > 0 && checkboxList.find('input:checked').val() !== '0') {
      hideFieldById(checkboxListId)
    } else {
      showFieldById(checkboxListId)
    }
  }

  if (elem.attr('type') === 'checkbox') {
    // для чекбоксов
    if (elem.prop('checked') === true && elem.val() !== 0) {
      hideFieldById(elem.val())
    } else {
      showFieldById(elem.val())
    }
  } else if (elem.attr('type') === 'radio') {
    // для радиокнопок
    const list = elem.parents('.form-checkbox__list')

    list.find('.form-input').each((index, item) => {
      const radioInputVal = $(item).find('input').val()

      showFieldById(radioInputVal)
    })

    if (elem.val() !== 0) {
      hideFieldById(elem.val())
    }
  } else {
    // для обычных инпутов, если валидное поле
    if (elem[0].checkValidity() && elem.val().length > 0) {
      hideFieldById(id)

    } else {
      showFieldById(id)
    }
  }
}

function dateRangeHideTrigger(field) {
  const elem = field
  const parentItem = elem.parents('.js-dateRangeId')
  const parentItemId = parentItem.attr('id')
  const dateFrom = parentItem.find('.js-dateInputFrom')
  const dateTo = parentItem.find('.js-dateInputTo')

  if (dateFrom.val().replace(/[^0-9]/g,'').length > 7 && dateTo.val().replace(/[^0-9]/g,'').length > 7) {
    hideFieldById(parentItemId)
  } else {
    showFieldById(parentItemId)
  }
}

$('.js-hideFormField .js-select').each((index, field) => {
  selectHideTrigger($(field))
})

$('.js-hideFormField input:not(.js-fileUploadInput)').each((index, field) => {
  inputHideTrigger($(field))
})

function showFieldById(currentId) {
  $(`[data-hide-id='${currentId}']`).show()
}

function hideFieldById(currentId) {
  $(`[data-hide-id='${currentId}']`).hide()
}

$(document).on('change', '.js-hideFormField .js-fileUploadInput', (event) => {
  const elem = $(event.currentTarget)
  const parent = elem.parents('.js-fileUpload')
  const id = parent.attr('id')

  if (parent.find('.file-upload-item')) {
    hideFieldById(id)
  } else {
    showFieldById(id)
  }
})

$(document).on('change', '.js-hideFormFieldDateRange input', (event) => {
  dateRangeHideTrigger($(event.currentTarget))
})

$('.js-hideFormFieldDateRange input').each((index, field) => {
  dateRangeHideTrigger($(field))
})

// что б не видно было как во время загрузки меняются данные
const stepWrapItem = $('.js-stepWrap')

if (stepWrapItem.length > 0) {
  const form = stepWrapItem.find('form')
  stepWrapItem.addClass('is-load')

  if ($('.js-selectedStep').length < 1) {
    stepWrapItem.addClass('last-step')
  }

  if (form.validate().checkForm()) {
    form.find('[type="submit"]').prop('disabled', false)
  } else {
    form.find('[type="submit"]').prop('disabled', true)
  }
}
